import type { FundModel } from '../../../../types';
import { sanitizeHTML } from '../../../../safe-html.mjs';
import { formatDate } from 'date-fns/format';
import { useTranslation } from 'react-i18next';

function FundOverview({ fund }: { fund: FundModel }) {
  const { t } = useTranslation();
  return (
    <div className='d-flex flex-column flex-xl-row mt-10'>
      <div className='flex-lg-row-fluid me-xl-15'>
        <div className='mb-17'>
          <div
            className='fs-5 fw-semibold text-gray-600'
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(fund.description) }}
          ></div>
        </div>
      </div>
      <div className='flex-column flex-lg-row-auto w-100 w-xl-400px mb-10'>
        <div className='timeline-label'>
          {fund.actualities?.map((c) => (
            <div className='timeline-item'>
              <div className='timeline-label fw-bold text-gray-800 fs-6'>
                {formatDate(c.date, 'dd MMM')}
              </div>
              <div className='timeline-badge'>
                <i className='fa fa-genderless text-warning fs-1'></i>
              </div>
              <div
                className='fw-mormal timeline-content text-muted ps-3'
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(c.content) }}
              ></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FundOverview;
